import { ComputedRef, reactive, watch } from 'vue';

interface ErrorOverlayState {
  isActive: boolean;
  errorTitle: string;
  errorMessage: string;
  showNavigationButton?: boolean;
}

const errorOverlayState: ErrorOverlayState = reactive({
  isActive: false,
  errorTitle: '',
  errorMessage: '',
  showNavigationButton: false
});

export function useGlobalErrorOverlay() {
  function setError(message: string, title: string, showNavigationButton?: boolean) {
    errorOverlayState.isActive = true;
    errorOverlayState.errorTitle = title;
    errorOverlayState.errorMessage = message;
    errorOverlayState.showNavigationButton = showNavigationButton || false;
  }

  function clearError() {
    errorOverlayState.isActive = false;
    errorOverlayState.showNavigationButton = false;
    errorOverlayState.errorTitle = '';
    errorOverlayState.errorMessage = '';
  }

  function watchStudyStatePreparing(isPreparing: ComputedRef<boolean>, t: (key: string) => string) {
    watch(
      isPreparing,
      (newVal) => {
        if (newVal) {
          setError(t('genericAccessErrorPreparingDescription'), t('genericAccessError'));
        } else {
          clearError();
        }
      },
      { immediate: true }
    );
  }

  return {
    errorOverlayState,
    setError,
    clearError,
    watchStudyStatePreparing
  };
}
